import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  papperWidthLg: {
    maxWidth: 1100,
  },
  fullWidth: {
    width: 'calc(100% - 32px)',
    margin: 16,
  },
  fullHeight: {
    height: '100%',
  },
  rounded: {
    background: '#fff',
    borderRadius: 0,
  },
  childrenRoot: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: 30,
    paddingTop: '50px !important',
    [theme.breakpoints.down(theme.size.sm)]: {
      padding: 15,
      paddingTop: 50,
    },
  },
  button: {
    position: 'absolute',
    top: 20,
    right: 20,
    minWidth: 'auto',
    padding: 2,
    borderRadius: '50%',
    background: '#F0F3F7',
  },
  closeIcon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
  backdrop: {
    background: 'rgba(34, 64, 96, .64)',
  },
}));
